__webpack_require__.p = "//st.moneydata.hk/res/weixin/hkwallet/v3/merchant-channel/";